require("./brokerCryptoNavigationCard.scss");
//  @vendors
import PropTypes from "prop-types";
// @enumerations
import { CryptoNavigationCardTypeEnum } from "./enums/brokerCryptoNavigationCard.enumerations";
// @components
import { RadioButton } from "commonsComponents/radioButton";

const CryptoNavigationCard = ({
    description,
    onIconClick,
    onClick,
    title,
    id,
    isSelected = false,
    type = CryptoNavigationCardTypeEnum.QUESTION,
}) => {
    const isQuestion = type === CryptoNavigationCardTypeEnum.QUESTION;
    const cardClass = [
        "crypto-navigation-card",
        isSelected && "crypto-navigation-card--selected",
        isQuestion
            ? "crypto-navigation-card--question"
            : "crypto-navigation-card--answer",
    ]
        .filter(Boolean)
        .join(" ");
    const textContainerClass = [
        "crypto-navigation-card-text-container",
        isQuestion
            ? "crypto-navigation-card-text-container--column"
            : "crypto-navigation-card-text-container--column-reverse",
    ].join(" ");

    return (
        <button
            className={cardClass}
            onClick={onClick}
            tabIndex={isQuestion ? 0 : -1}
            aria-disabled={!isQuestion}
        >
            <div className={textContainerClass}>
                {description && (
                    <span className="crypto-navigation-card-description">
                        {description}
                    </span>
                )}
                <span
                    className={`crypto-navigation-card-title${
                        type === CryptoNavigationCardTypeEnum.QUESTION
                            ? "-question"
                            : ""
                    }`}
                >
                    {title}
                </span>
            </div>
            {isQuestion ? (
                <RadioButton
                    className={`crypto-navigation-card__radio`}
                    isChecked={isSelected}
                    value={id}
                />
            ) : (
                <div className="crypto-navigation-card__edit-icon-container">
                    <i
                        className="crypto-navigation-card__edit-icon"
                        onClick={onIconClick}
                        onKeyDown={(e) =>
                            e.key === "Enter" && onIconClick && onIconClick(e)
                        }
                        tabIndex={0}
                        role="button"
                        aria-disabled={false}
                    />
                </div>
            )}
        </button>
    );
};

CryptoNavigationCard.propTypes = {
    description: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    onIconClick: PropTypes.func,
    title: PropTypes.string.isRequired,
    type: PropTypes.string,
    isSelected: PropTypes.bool,
    id: PropTypes.string,
};

export { CryptoNavigationCard };
